import { CreateOrUpdateFunction } from '@/utils/classes/ApiController'
import { VueForm } from '@/utils/interfaces'
import { computed, ref, Ref, watch, SetupContext } from '@vue/composition-api'

export const crudEditComposition = <B, R>(
  props: {
    editedItem?: null | { uuid: string }
    value: boolean
  },
  ctx: SetupContext,
  defaultCrud: object,
  poster: CreateOrUpdateFunction<B, R>,
  noValidate?: boolean,
  validateFunction?: () => true,
  rejectFunction?: () => true,
) => {
  const isEdition = computed(() => !!props.editedItem?.uuid)

  const form = ref<null | VueForm>(null)

  const loading = ref(false)

  const crud = ref(JSON.parse(JSON.stringify(defaultCrud))) as Ref<B>

  const onSuccess = async () => {
    if (!noValidate) {
      if (!form.value?.validate()) return
    }
    if (validateFunction && !(await validateFunction())) return
    try {
      loading.value = true
      const response = await poster(crud.value)
      ctx.emit('new-item', response.data)
      ctx.emit('input', false)
    } finally {
      loading.value = false
    }
  }

  const onReject = async () => {
    if (rejectFunction && !(await rejectFunction())) return
    ctx.emit('input', false)
  }

  function updateCrud() {
    crud.value = JSON.parse(JSON.stringify(props.editedItem || defaultCrud))
    form.value?.resetValidation()
  }

  watch(() => props.editedItem, updateCrud)

  watch(
    () => props.value,
    (value: boolean) => {
      if (value) updateCrud()
    },
  )

  return {
    crud,
    form,
    isEdition,
    loading,
    onSuccess,
    onReject,
  }
}
